<div style="display: flex; align-items: center; justify-content: center; height: 75vh">
    <nz-card>
        <div style="display: flex; flex-direction: column; align-items: center;">
            <p>Click the Clear 2FA button to remove second factor authentication from your account.</p>
            <button nz-button nzType="primary" (click)="clear()" style="margin-top: 10px">Clear 2FA</button>
        </div>
    </nz-card>
</div>